<template>
  <section
    v-if="vision"
    id="single-page"
  >
    <BaseBasicPage :page-content="vision" />
  </section>
</template>

<script>
import BaseBasicPage from '../components/base/BaseBasicPage'
import gql from 'graphql-tag'

export default {
    apollo: {
        vision: {
            query: gql `
            query Vision {
                vision {
                  content_en
                  content_no
                }
            }
        `
        }
    },
    metaInfo() {
        return { 
            title: this.$t("nav.visions"),
        }
    },
    components: {
        BaseBasicPage
    }
}
</script>